import React from "react";

import styles from "../../../../styles/secrets-drawers.module.scss";
import { Drawer } from "../../../components/Drawer";
import { Input } from "../../../components/Input";
import { Button } from "../../../components/Button";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { Icon } from "../../../components/core/Icon";
import { AssetsAPI } from "../../../../providers/AssetsAPI";
import { Checkbox } from "../../../components/Checkbox";

export default class HoldingLogoDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      active: true,
      logo: null,
      primaryColor: null,
      secondaryColor: null,
    };
  }

  async componentDidMount() {
    const environmentId = await EnvironmentStorage.getEnvironmentHoldingId();

    const holdingResponse = await EnvironmentsAPI.getById(environmentId);
    const holding = holdingResponse.getData({ avatar: null });

    const frontTheme =
      (await EnvironmentsAPI.getConfigurationsByAlias(
        environmentId,
        "front_theme"
      )) || {};
    const primaryColor = frontTheme.primaryColor;

    this.setState({
      logo: holding.avatar,
      active: holding.active,
      primaryColor,
    });
  }

  async updateLogo() {
    const { logo, active, primaryColor } = this.state;

    this.setState({ loading: true });
    const environmentId = await EnvironmentStorage.getEnvironmentHoldingId();
    const holdingResponse = await EnvironmentsAPI.getById(environmentId);
    const frontTheme =
      (await EnvironmentsAPI.getConfigurationsByAlias(
        environmentId,
        "front_theme"
      )) || {};

    const brand = holdingResponse.getData({
      name: "",
      alias: "",
      type: "BRAND",
      active: true,
    });

    const { name } = brand;

    const updateResponse = await EnvironmentsAPI.putUnit(environmentId, {
      name,
      active,
      avatarUrl: logo,
    });

    if (updateResponse.getErrors([]).length > 0) {
      alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
      this.setState({ loading: false });
      return false;
    }

    const frontThemeResponse = await EnvironmentsAPI.putConfigurationsByAlias(
      environmentId,
      "front_theme",
      { front_theme: { ...frontTheme, primaryColor } }
    );

    if (frontThemeResponse.getErrors([]).length > 0) {
      alert({ text: frontThemeResponse.getErrors()[0], buttonText: "Ok" });
      this.setState({ loading: false });
      return false;
    }

    alert({
      text: "Configurações alteradas sucesso",
      buttonText: "Ok",
    });

    this.setState({ loading: false });

    return true;
  }

  async handleSetImage(e) {
    const file = e.target.files[0];

    if (file) {
      const maxFileSize = 5;
      const fileSize = file.size / 1024 / 1024;
      const fileType = file.type;

      if (fileSize > maxFileSize) {
        alert({ text: `Escolha um arquivo com no máximo ${maxFileSize}MB` });
        return false;
      }

      const pattern = /image-*/;

      if (!fileType.match(pattern)) {
        alert({ text: "Arquivo inválido." });
        return false;
      }

      let reader = new FileReader();
      reader.onload = async (readerEvent) => {
        const response = await AssetsAPI.PostAssets({
          mime_type: fileType,
          file: readerEvent.target.result.split("base64,")[1],
        });

        this.setState({ logo: response.getData("") });
      };

      reader.readAsDataURL(file);
    }
  }

  render() {
    const { loading, logo, active, primaryColor } = this.state;
    const { visible, onClose } = this.props;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Logo da Holding"
      >
        <div className={styles.secretDrawerContainer}>
          <div className={styles.container}>
            <div className="d-flex align-center">
              <label htmlFor="brand-picture" className={styles.customFileInput}>
                <span className={styles.plus}>
                  <Icon name="plus" color="#fff" />
                </span>
                <input
                  type="file"
                  id="brand-picture"
                  accept="image/*"
                  onChange={(e) => this.handleSetImage(e)}
                />
                {logo ? (
                  <img src={`${process.env.REACT_APP_ASSETS_URL}/${logo}`} />
                ) : (
                  <Icon name="image-polaroid" size="2x" light />
                )}
              </label>
            </div>
            <Input
              design="two"
              className="mb-20"
              floatLabel="Cor primária"
              value={primaryColor}
              onChange={(e) => {
                this.setState({ primaryColor: e.target.value });
              }}
            />
            {/* <Checkbox
                            name={`brand_active`}
                            design="two"
                            checked={active}
                            onChange={(value) => this.setState({ active: value })}
                        >
                            Plataforma ativada?
                        </Checkbox> */}
          </div>

          <div className={styles.footer}>
            <Button
              design="primary"
              className="w-100"
              onClick={() => this.updateLogo()}
              loading={loading}
              disabled={loading}
            >
              Salvar
            </Button>
          </div>
        </div>
      </Drawer>
    );
  }
}
